import * as cart from '@assets/i18n/es/cart.json';
import * as common from '@assets/i18n/es/common.json';
import * as importExport from '@assets/i18n/es/importExport.json';
import * as product from '@assets/i18n/es/product.json';
import * as productImageZoom from '@assets/i18n/es/productImageZoom.json';
import * as savedCart from '@assets/i18n/es/savedCart.json';
import * as user from '@assets/i18n/es/user.json';
import * as userAccount from '@assets/i18n/es/userAccount.json';
import * as checkout from '@assets/i18n/es/checkout.json';
import * as address from '@assets/i18n/es/address.json';
import * as order from '@assets/i18n/es/order.json';
import * as quote from '@assets/i18n/es/quote.json';
import * as unitOrder from '@assets/i18n/es/unitOrder.json';

export const translationsEs = {
  cart,
  common,
  importExport,
  product,
  productImageZoom,
  savedCart,
  user,
  userAccount,
  checkout,
  address,
  order,
  quote,
  unitOrder,
};
